import React from 'react';
import images from '../const/images';

const imagePath = '/iconsfr/';

const UserAvatar = React.memo(({ user, size = 40, showSession = false, stack = false, suspension = false }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    backgroundColor: `#${user.color}`,
  };

  const avatarClass = `user-avatar ${stack ? 'stacked' : ''}`;

  if (showSession) {
    return (
      <div className="user-info">
        <div style={style} className={avatarClass}>
          {suspension ? (
            <span style={{ fontSize: `${size * 0.6}px` }}>⏸️</span>
          ) : (
            user.image && (
              <img 
                src={`${imagePath}${images[user.image - 1]}.png`} 
                alt={images[user.image - 1]} 
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            )
          )}
        </div>
        <div className="user-details">
          <div className="user-name">{user.name}</div>
          <div className="user-role">
            {user.currentsession ? (
              <>
                {user.role === 0 && 'Rédacteur '}
                {user.role === 1 && 'Évaluateur '}
                {user.role === 2 && 'Spectateur '}
                dans la session {user.currentsession}
              </>
            ) : (
              'Pas de session'
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={style} className={avatarClass}>
      {suspension ? (
        <span style={{ fontSize: `${size * 0.6}px` }}>⏸️</span>
      ) : (
        user.image && (
          <img 
            src={`${imagePath}${images[user.image - 1]}.png`} 
            alt={images[user.image - 1]} 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        )
      )}
    </div>
  );
}, (prevProps, nextProps) => {
  // Comparaison personnalisée pour éviter les re-renders inutiles
  return prevProps.user.id === nextProps.user.id &&
         prevProps.user.name === nextProps.user.name &&
         prevProps.user.image === nextProps.user.image &&
         prevProps.user.color === nextProps.user.color &&
         prevProps.user.role === nextProps.user.role &&
         prevProps.user.currentsession === nextProps.user.currentsession &&
         prevProps.size === nextProps.size &&
         prevProps.showSession === nextProps.showSession &&
         prevProps.stack === nextProps.stack &&
         prevProps.suspension === nextProps.suspension;
});

UserAvatar.displayName = 'UserAvatar';

export default UserAvatar;